<template>
  <div ref="card">
    <div class="section-header">
      <ConstructorComponentsSectionHeader
        :title="data.title"
        class="section-carousel"
      />
      <ui-link-triangle
        v-if="data.links"
        :url="data.links.to"
        :title="data.links.name"
        :mobile-title="data.links.mobileName"
        color="#363EF8"
      />
    </div>
    <div class="slider-wrap">
      <ui-multiple-swiper
        :free-mode="isMobile"
        :space-between="spaceBetween"
        class="all-article-container"
      >
        <ui-multiple-swiper-slide
          v-for="(item, index) in data.items"
          :key="`${item.id}_${index}`"
          class="article-snippet"
        >
          <card-offer-tile
            v-if="item.type == 'offer'"
            :data-slot="index + 1"
            :data-url="objToBase64({ url: item.view_url })"
            :data-offer_id="item.id"
            data-block="carousel"
            :model="isMobile ? { ...item, additional_images: [] } : item"
            type-style="tile"
            :type="item.type"
            class="card"
            viewed
            :position="index + 1"
            block-type="model-similar"
          />
        </ui-multiple-swiper-slide>
      </ui-multiple-swiper>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { OfferListBlockContent } from '~/interfaces/constructor';
import { useAnalyticsStore } from '~/stores/analytics';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import cardOfferTile from '~/components/product-card/productCardTileOffer/productCardTileOffer.vue';
import { objToBase64 } from '~/utils/base64';

defineEmits(['openModal']);
defineProps({
  data: {
    type: Object as () => OfferListBlockContent,
    required: true,
  },
  white_buttons: {
    type: Boolean,
    default: false,
  },
});
const mediaStore = useMediaQueryStore();
const analyticsStore = useAnalyticsStore();
const card = ref<HTMLElement | undefined>();
const isMobile = computed(
  () =>
    mediaStore.isMobile || mediaStore.isEs || mediaStore.isSm || mediaStore.isMd
);
const spaceBetween = computed(() =>
  mediaStore.isEs || mediaStore.isSm ? 8 : mediaStore.isMd ? 12 : 16
);
onMounted(() => {
  nextTick(() => {
    observeElements();
  });
});

onBeforeUnmount(() => {
  observeElements(true);
});

function observeElements(unobserve = false) {
  const list: NodeListOf<HTMLElement> | undefined =
    card.value?.querySelectorAll('div.item.carousel');
  if (list?.length) {
    list.forEach((e: HTMLElement) => {
      unobserve
        ? analyticsStore.unobserveView(e)
        : analyticsStore.observeView(e);
    });
  }
}
</script>
<style lang="scss" src="./CarouselScss.scss" scoped></style>
